import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { Page } from '@app/components/page/Page';
import { useToast } from '@app/core/notifications';
import { pushTo } from '@app/core/routing';
import { DailymotionPlatform } from '@app/modules/social-export/domain/platforms';
import { zodResolver } from '@hookform/resolvers/zod';
import { useSocialExportConnectDailymotionApiKey } from '@mi-front/api-v2';
import { Grid, Stack } from '@mui/material';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';

/**
 * Client-level Dailymotion API-key connect form (no station). Assign stations after connect.
 */
export function DailymotionApiKeyConnectPage() {
  const { $t } = useIntl();
  const { notifyError } = useToast();
  const mutation = useSocialExportConnectDailymotionApiKey();

  return (
    <Page>
      <Page.Header
        icon={DailymotionPlatform.Icon()}
        title={$t({
          id: 'socialExport.dailymotion.connectApiKeyTitle',
          defaultMessage: 'Conectar Dailymotion via API key',
        })}
      />
      <Page.Content>
        <FormContainer
          mode="onBlur"
          values={{
            key: '',
            secret: '',
            channelId: '',
          }}
          onSuccess={async (data) => {
            try {
              const result = await mutation.mutateAsync({ data });
              pushTo(
                `/admin/social-export/dailymotion/settings/${result.id}?connectResult=success`,
              );
            } catch (error: unknown) {
              notifyError((error as Error).message);
            }
          }}
          resolver={zodResolver(
            z.object({
              key: z.string().min(1),
              secret: z.string().min(1),
              channelId: z.string().min(7).max(7),
            }),
          )}
        >
          <Stack spacing={4} useFlexGap>
            <Grid container>
              <Grid item md={6}>
                <TextFieldElement
                  label={$t({
                    id: 'socialExport.dailymotion.apiKey',
                    defaultMessage: 'API key',
                  })}
                  name={'key'}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={6}>
                <TextFieldElement
                  label={$t({
                    id: 'socialExport.dailymotion.apiSecret',
                    defaultMessage: 'API secret',
                  })}
                  name={'secret'}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={3}>
                <TextFieldElement
                  label={$t({
                    id: 'socialExport.dailymotion.channelId',
                    defaultMessage: 'ID de canal',
                  })}
                  name={'channelId'}
                  required
                  fullWidth
                  helperText={$t({
                    id: 'socialExport.dailymotion.channelIdHelper',
                    defaultMessage: 'Identificador de 7 caracteres',
                  })}
                  inputProps={{
                    maxlength: 7,
                  }}
                />
              </Grid>
            </Grid>
            <FormActionsMui />
          </Stack>
        </FormContainer>
      </Page.Content>
    </Page>
  );
}
